import set from 'ramda/src/set'
import lensPath from 'ramda/src/lensPath'

import { CHANGE_VARIANT_ROUTE_INDEX } from 'root/src/client/logic/route/actionIds'

export default {
	[CHANGE_VARIANT_ROUTE_INDEX]: (state, payload) => set(lensPath(['route', 'variantRouteIndex']), payload, state),
}
